let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("l6dWA")).then(() => parcelRequire('h7n9s'));